// extracted by mini-css-extract-plugin
module.exports = {"active":"Navigation_active__lzwHd","disable":"Navigation_disable__5xE8h","disabled":"Navigation_disabled__Dmvjk","nav":"Navigation_nav__3zs4_"};